export const getLoading = state => state.loading.loading;
export const getUser = state => state.user;
export const getErrorMessage = state => state.message.errors;
export const getSuccessMessage = state => state.message.success;
export const getResources = state => state.resources;
